// theme-theme-utils.ts
export type HeroVariant = 'cvte' | 'wnt';

export interface ThemeConfig {
  isRijksTheme: boolean;
  logoVariant?: HeroVariant;
  logoUrl?: string;
  logoAltText?: string;
}

export function getThemeConfig(theme?: string): ThemeConfig {
  if (theme === 'cvte') {
    return {
      isRijksTheme: true,
      logoVariant: 'cvte',
      logoUrl: './assets/images/logo-cvte.svg',
      logoAltText: 'Logo College voor Toetsen en Examens',
    };
  }
  if (theme === 'wnt') {
    return {
      isRijksTheme: true,
      logoVariant: 'wnt',
      logoUrl: './assets/images/logo-wnt.svg',
      logoAltText:
        'Logo Ministerie van Binnenlandse Zaken en Koninkrijksrelaties',
    };
  }
  return { isRijksTheme: false };
}
